import React, { useState, useEffect, useRef } from 'react'
import { FixedSizeList as List } from 'react-window'

export default function CheckboxDropdownList({
  users = [],
  options = [],
  onSelectionChange,
  onSearchChange,
  onLoadMore,
  disabled = false,
  occupiedUsersData = {},
}) {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState(new Set())
  const [search, setSearch] = useState('')
  const filterContainer = useRef(null)
  const listRef = useRef(null)
  const outerRef = useRef(null) 

  useEffect(() => {
    const usersInStateArray = users.map((u) => u.uid)
    setSelectedOptions(new Set(usersInStateArray))
  }, [users])

  const handleOutsideClick = (e) => {
    if (filterContainer.current && !filterContainer.current.contains(e.target)) {
      setDropdownOpen(false)
    }
  }

  useEffect(() => {
    if (search.length >= 3) onSearchChange?.(search)
    if (search.length === 0) onSearchChange?.('')
  }, [search])

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  const handleFilterSearch = (e) => setSearch(e.target.value)

  const isOccupied = (optionValue) => occupiedUsersData[optionValue]

  const selectOption = (optionValue) => {
    if (disabled) return
    const newSelectedOptions = new Set(selectedOptions)
    if (newSelectedOptions.has(optionValue)) {
      newSelectedOptions.delete(optionValue)
    } else {
      newSelectedOptions.add(optionValue)
    }
    setSelectedOptions(newSelectedOptions)
    onSelectionChange(newSelectedOptions)
  }

  const handleScroll = () => {
    const listElement = outerRef.current 
    if (listElement) {
      const { scrollTop, scrollHeight, clientHeight } = listElement
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        onLoadMore?.()
      }
    }
  }

  const filteredOptions = options

const Row = ({ index, style }) => {
  const option = filteredOptions[index]
  const alreadyAssigned = option.price_list && option.price_list.trim() !== ''
  const occupiedUser = isOccupied(option.value)

  const isDisabled = disabled || occupiedUser || alreadyAssigned

  return (
    <div
      style={style}
      className="react-filter-option"
      onClick={() => (!isDisabled ? selectOption(option.value) : null)}
    >
      <input
        type="checkbox"
        className={`filter-checkbox${isDisabled ? '-disabled' : ''}`}
        readOnly
        checked={selectedOptions.has(option.value) || isDisabled}
        disabled={isDisabled}
      />
      <div className={`dropdown-checkbox-label${isDisabled ? '-disabled' : ''}`}>
        {option.label}
        {occupiedUser
          ? ` - ASIGNADO A: ${occupiedUser}`
          : alreadyAssigned
          ? ` - POSEE LISTA (${option.price_list})`
          : ''}
      </div>
    </div>
  )
}

  return (
    <div
      className={`checkbox-dropdown-input-box ${disabled ? 'react-filter-disabled' : ''}`}
      ref={filterContainer}
    >
      <div
        onClick={() => !disabled && setDropdownOpen(!isDropdownOpen)}
        className="react-filter-box-clickable-zone"
      >
        <input
          type="search"
          className="checkbox-dropdown-search-input"
          placeholder="Buscar cliente(s) por nombre o código"
          value={search}
          onChange={handleFilterSearch}
          disabled={disabled}
        />
        {search && <div onClick={() => setSearch('')} className="filter-search-input-x"></div>}
      </div>

      {isDropdownOpen && (
        <div
          className="checkbox-list-dropdown-box box-transition scrollable-container"
        >
          <List
            ref={listRef}
            outerRef={outerRef} 
            height={Math.min(filteredOptions.length * 35, 400)}
            itemCount={filteredOptions.length}
            itemSize={35}
            width="100%"
            onScroll={handleScroll}
          >
            {Row}
          </List>
        </div>
      )}
    </div>
  )
}